var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSequencing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 160,
    viewBox: "0 0 51 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.822 96.666C50.822 83.6906 25.4077 36.9736 25.4077 36.9736C25.4077 36.9736 0 83.6906 0 96.666C0 109.641 11.3767 120.164 25.4077 120.164C39.4387 120.164 50.822 109.628 50.822 96.666Z",
    fill: "#F4B39E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1558 152.935C32.1558 154.265 28.9335 155.229 25.0049 155.149C21.0762 155.069 17.92 153.959 17.9465 152.656",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1558 152.935C32.1558 154.265 28.9335 155.229 25.0049 155.149C21.0762 155.069 17.92 153.959 17.9465 152.656",
    stroke: "#0C0E1F",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9238 97.4102L17.9268 152.656C17.9268 153.985 21.0104 157.734 24.939 157.807C28.8677 157.88 32.1163 154.231 32.1361 152.935L32.8558 97.7625",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9238 97.4102L17.9268 152.656C17.9268 153.985 21.0104 157.734 24.939 157.807C28.8677 157.88 32.1163 154.231 32.1361 152.935L32.8558 97.7625",
    stroke: "#1C1E2C",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8425 97.8028C32.8425 96.7393 29.7721 95.8086 25.9424 95.7422C22.1128 95.6757 18.9964 96.4734 18.9766 97.5369",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8425 97.8028C32.8425 96.7393 29.7721 95.8086 25.9424 95.7422C22.1128 95.6757 18.9964 96.4734 18.9766 97.5369",
    stroke: "#1C1E2C",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9912 110.711C23.6977 110.791 24.4439 110.838 25.2231 110.851C29.396 110.931 32.7965 110.06 32.8229 108.903",
    stroke: "#1C1E2C",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9912 105.068C23.6977 105.141 24.4439 105.187 25.2231 105.201C29.396 105.28 32.7965 104.41 32.8229 103.253",
    stroke: "#1C1E2C",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9912 99.4183C23.6977 99.4914 24.4439 99.5379 25.2231 99.5512C29.396 99.631 32.7965 98.7601 32.8229 97.6035",
    stroke: "#1C1E2C",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M31.225 10.9232C31.225 12.5451 28.8613 13.8147 26.0089 13.7615C23.1564 13.7083 20.8785 12.3457 20.9049 10.7237L20.0068 4.82094C20.0068 3.19901 22.8264 1.93604 26.2334 2.00251C29.6405 2.06898 32.3807 3.43832 32.3477 5.06026L31.225 10.9232Z",
    fill: "#F4B39E"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2987 7.71251C24.9012 7.8134 25.5104 7.86895 26.1211 7.87869C29.5281 7.94516 32.3146 6.68219 32.3477 5.06026C32.3807 3.43832 29.6405 2.06898 26.2334 2.00251C22.8264 1.93604 20.0399 3.19901 20.0068 4.82094L20.9049 10.7237C20.9049 12.3457 23.163 13.7083 26.0089 13.7615C28.8547 13.8147 31.192 12.5451 31.225 10.9232",
    stroke: "#1C1E2C",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0156 13.7617V61.3096",
    stroke: "#1C1E2C",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8503 76.777C32.8163 76.777 25.8503 60.3184 25.8503 60.3184C25.8503 60.3184 18.4023 76.777 25.8503 76.777Z",
    fill: "white",
    stroke: "#1C1E2C",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0762 106.923C42.6052 105.825 43.8549 104.379 44.7235 102.703C45.5921 101.027 46.055 99.1678 46.0744 97.2773C46.0744 94.7514 44.2456 89.7925 41.9412 84.5479",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSequencing);
export default __webpack_public_path__ + "static/media/sequencing.296d4577d67eb86412f94d3015ebf318.svg";
export { ForwardRef as ReactComponent };